// extracted by mini-css-extract-plugin
export default {"form":"NewStrategy_form__hUYr2","select":"NewStrategy_select__cE0v5"};